import * as React from "react";
import {
    Routes,
    Route,
    Link,
    useNavigate,
    useLocation,
    Navigate,
    Outlet,
  } from "react-router-dom";
import { unauthenticatedApi, getAccessToken, authenticatedApi, setAccessToken, tokenName, serialize } from "../api";
import { isConductor } from "@utils/tenant";

export const TenantContext = React.createContext({
    tenant: null,
    setTenant: (tenant) => {},
    isLoading: true,
    isNotFound: false,
    isInactive: false,

    connectedAccounts: {},
    setConnectedAccounts: (accounts) => {},
    getConnectedAccounts: async () => {},
  });

export function useTenant() {
    return React.useContext(TenantContext);
}

export function TenantProvider({ children }) {
    const [tenant, setTenant] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(true);
    const [isNotFound, setIsNotFound] = React.useState(false);
    const [isInactive, setIsInactive] = React.useState(false);
    const [connectedAccounts, setConnectedAccounts] = React.useState({});

    React.useEffect(() => {
      /*
      if(tenant !== null) {
        let checkToken = getAccessToken();
        if(checkToken) {
          getConnectedAccounts();
        }
      }
      */

      if(isLoading && tenant == null) {
        if(isConductor) {
          setIsLoading(false);
          return;
        }
        unauthenticatedApi.get('/installs/current?include=all').then(response => {
          setTenant(response.data);

          if(!response.data.active) {
            setIsInactive(true);
          }
        }).catch(e => {
          setIsNotFound(true);
        }).finally(() => {
          // setTimeout(() => {
            setIsLoading(false);
          // }, 1000);
        });
      }
    }, [tenant]);

    const getConnectedAccounts = async () => {
      let mailchimp = {status: false, value: null, contact: null};
      let constantContact = {status: false, value: null};

      let newConnectedAccounts = {};

      if(tenant !== null && tenant.connected_accounts != null) {
        for(let acct of tenant.connected_accounts) {
          if(acct.account_type == 'mailchimp') {
            mailchimp.value = acct;
          } else if(acct.account_type == 'constant_contact') {
            constantContact.value = acct;
          }
        }
      }

      if(mailchimp.value != null) {
        var $data = {
          url: mailchimp['value']['payload']['endpoint'] + "/3.0/",
          method: 'GET',
          headers: ['Authorization: Basic ' + btoa('anytext:' + mailchimp['value']['payload']['token'])]
        };

        // this has await to ensure that we don't override constant contact
        await authenticatedApi.post('proxy?'+serialize($data), {}, false).then(response => response.data).then(response => {
          mailchimp['status'] = response['account_id'] ? 'connected' : 'broken';

          if (response['account_id']) {
            mailchimp.contact = {
              company: response['contact']['company'],
              address1: response['contact']['addr1'],
              address2: response['contact']['addr2'],
              city: response['contact']['city'],
              state: response['contact']['state'],
              zip: response['contact']['zip'],
              country: response['contact']['country'],
            };
          }

          // newConnectedAccounts.mailchimp = mailchimp;
          /*
          setConnectedAccounts({
            ...connectedAccounts,
            mailchimp,
          });
          setTimeout(() => {
            console.log(connectedAccounts);
          }, 5);
          */
        }).catch(e => {
          // console.log(e);
          mailchimp['status'] = 'broken';
        }).finally(() => {
          newConnectedAccounts.mailchimp = mailchimp;
        });
      }

      if(constantContact.value != null) {
        var $data = {
          url: "https://oauth2.constantcontact.com/oauth2/tokeninfo.htm",
          method: 'POST',
          headers: ['Content-Type: application/x-www-form-urlencoded'],
          data: 'access_token='+constantContact['value']['payload']['token']
        };

        await authenticatedApi.post('proxy?'+serialize($data), {}, false).then(response => response.data).then(response => {
          // console.log(response);
          constantContact['status'] = response['client_id'] ? 'connected' : 'broken';

          newConnectedAccounts.constantContact = constantContact;
          /*
          setConnectedAccounts({
            ...connectedAccounts,
            constantContact,
          });
          setTimeout(() => {
            console.log(connectedAccounts);
          }, 5);
          */
        }).catch(e => {
          // console.log(e);
          constantContact['status'] = 'broken';
        }).finally(() => {
          newConnectedAccounts.constant_contact = constantContact;
        });
      }

      setConnectedAccounts(newConnectedAccounts);
    }

    let value = {
      tenant,
      setTenant,
      isLoading,
      isNotFound,
      isInactive,
      // installSettings,
      // setInstallSettings,
      connectedAccounts,
      setConnectedAccounts,
      getConnectedAccounts,
    };

    return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
}
